<template>
  <div class="processPage">
    <ul class="ulBox clearFloat">
      <li class="blockLi">
        <div class="right">
          <el-table
            :row-class-name="tableRowClassName"
            :data="itemList" stripe border style="width: 100%" size="mini">
            <el-table-column type="index" align="center"/>
            <el-table-column label="入库凭证号" min-width="120px" prop="mblnr" align="center">
              <template slot-scope="scope">
                <el-tooltip v-if="scope.row.xblnr" :content="'入库单号：'+scope.row.xblnr" class="item" effect="dark" placement="top" :open-delay="300">
                  <span class="textOverflow">{{scope.row.mblnr ? scope.row.mblnr : '-'}}</span>
                </el-tooltip>
                <span v-else class="textOverflow">
                  {{scope.row.mblnr ? scope.row.mblnr : '-'}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="物料编码" min-width="150px" prop="matnr" align="center">
              <template slot-scope="scope">
                <el-tooltip v-if="scope.row.matnx" :content="scope.row.matnx" class="item" effect="dark" placement="top" :open-delay="300">
                  <span>{{scope.row.matnr ? scope.row.matnr : '-'}}</span>
                </el-tooltip>
                <span v-else>{{scope.row.matnr ? scope.row.matnr : '-'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="批次号" min-width="150px" prop="charg" align="center">
              <template slot-scope="scope">                
                <span class="textOverflow">
                  {{scope.row.charg ? scope.row.charg : '-'}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="过账日期" min-width="90px" prop="budat" align="center">
              <template slot-scope="scope">                
                <span class="textOverflow">
                  {{scope.row.budat ? scope.row.budat : '-'}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="数量" min-width="80px" prop="menge" align="center">
              <template slot-scope="scope">                
                <span class="textOverflow">
                  {{scope.row.menge}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="入库单号" min-width="150px" prop="xblnr" align="center">
              <template slot-scope="scope">
                <el-tooltip v-if="scope.row.xblnr" :content="scope.row.xblnr" class="item" effect="dark" placement="top" :open-delay="300">
                  <span class="textOverflow">
                    {{scope.row.xblnr}}
                  </span>
                </el-tooltip>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="接收工厂" min-width="80px" prop="werks" align="center">
              <template slot-scope="scope">
                <el-tooltip v-if="scope.row.werkstx" :content="scope.row.werkstx" class="item" effect="dark" placement="top" :open-delay="300">
                  <span class="textOverflow">
                    {{scope.row.werks}}
                  </span>
                </el-tooltip>
                <span v-else class="textOverflow">
                    {{scope.row.werks ? scope.row.werks : '-'}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="库存地点" min-width="80px" prop="lgort" align="center">
              <template slot-scope="scope">
                <el-tooltip v-if="scope.row.lgorttx" :content="scope.row.lgorttx" class="item" effect="dark" placement="top" :open-delay="300">
                  <span class="textOverflow">
                    {{scope.row.lgort}}
                  </span>
                </el-tooltip>
                <span v-else class="textOverflow">
                  {{scope.row.lgort ? scope.row.lgort : '-'}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="移动类型" min-width="80px" prop="bdmng" align="center">
              <template slot-scope="scope">                
                <span class="textOverflow">
                  {{scope.row.bwart ? scope.row.bwart : '-'}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="入库员" max-width="80px" prop="bdmng" align="center">
              <template slot-scope="scope">
                <el-tooltip v-if="scope.row.user" :content="scope.row.user.name +'('+scope.row.user.employeeNum+') '+scope.row.createDateTime" class="item" effect="dark" placement="top" :open-delay="300">
                  <span class="textOverflow">{{ scope.row.user.name }}({{scope.row.user.employeeNum}})</span>
                </el-tooltip>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column class-name="operation" max-width="80px" label="操作" align="center">
              <template slot-scope="scope">
                <el-tooltip v-if="$parent.orderStatus=='REL' && !scope.row.rollbackId" content="取消入库" class="item" effect="dark" placement="top" :open-delay="300">
                  <i @click="rollbackBtn($event, scope.row)" class="iconfont icon-quxiao"></i>
                </el-tooltip>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </li>
    </ul>    
    <myDialog ref="myDialog"
        :title="dialogTitle" @submitData="submitData" @dialogClose="dialogClose">
      <template slot="content">
        <el-form ref="dialogForm" :model="dialogForm" :rules="dialogRules" :label-width="labelWidth">
          <el-form-item label="存放仓库：" size="small" prop="lgort">
            <el-select v-model="dialogForm.lgort" placeholder="选择存放仓库" filterable clearable >
              <el-option
                v-for="(item, index) in lgortList"
                :key="index"
                :label="'【'+item.lgort+'】'+item.name"
                :value="item.lgort"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入库单号：" size="small" prop="xblnr">
            <el-input v-model="dialogForm.xblnr" clearable maxlength="16" placeholder="检验单号"/>
          </el-form-item>
          <el-form-item label="入库数量：" size="small" class="inlineItem" prop="menge">
            <el-input-number :controls="false" :precision="3" :min="0" :max="9999999999.999"
             v-model="dialogForm.menge" id="rebateInput_pcs"/>
          </el-form-item>
          <el-button style="margin-left:10px" size="small" @click="validXblnr" icon="el-icon-search">校验</el-button>
          <el-form-item label="备注：" size="small">
            <el-input type="textarea" maxlength="40" 
              :rows="2" v-model="dialogForm.notes" placeholder="备注信息" clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>
<script>
import myDialog from "@/components/myDialog.vue";
import {
  apiSapStorageSearch,apiSapDetail,apiSapOrderStorageRollback,
  apiSapOrderStorage,apiSapLgortList,apiSapOrderValidXblnr,apiSapOrderStoragePrint
} from "@/api/SapOrder.js";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
  },
  computed: {
  },
  components: {   
    myDialog 
  },
  data() {
    return {
      detailData: {},
      lgortList: null,
      itemList:[],
      dialogTitle: "【未命名】",
      dialogForm: {},      
      labelWidth: this.$store.state.labelWidth,
      dialogRules: {
        xblnr: [{ required: true, message: "入库单号不能为空！", trigger: "blur" }],
        menge: [
          { required: true, message: "入库数量不能为空！", trigger: "blur" },
          {type:"number", min:0.001, message: "入库数量不能小于等于0！"}
        ],
        lgort: [{ required: true, message: "存放仓库不能为空！", trigger: "blur" }]
      }
    };
  },
  methods: {
    tableRowClassName({row}) {
      if (row.rollbackId) {
        return 'warning-row';
      }
      return '';
    },
    async onStorage() {
      let res = await apiSapDetail({
        id: this.tabPaneValue,
      });
      if (res.code == 0) {
        this.detailData = res.data;
      }
      res = await apiSapLgortList({
        id: this.detailData.id,
        weknr: this.detailData.werks
      });
      if (res.code == 0) {
        this.lgortList = res.data;
      }
      this.dialogTitle = "SAP入库";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        menge:0,
        xblnr: "",
        lgort: ""
      };

      setTimeout(() => {
        // 为el-input-number添加单位
        this.addSuffix("rebateInput_pcs", "PCS");      
      }, 100);
    },
    rollbackBtn(e, row) {
      const h = this.$createElement;
      this.$msgbox({
        title: `SAP取消入库`,
        message: h("div", null, [
          h("span", null, `请输入入库数量:【`),
          h("i", { style: "color: var(--themeColor)" }, row.menge),
          h("span", null, `】以确认取消入库！`)
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            if (instance.inputValue == row.menge) {
              done()
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`
              })
            }
          } else {
            done()
          }
        }
      }).then(async () => {
        const res = await apiSapOrderStorageRollback({
          id: row.id,
        });
        if (res.code == 0) {
          this.lgortList=[];
          this.onSearch();
          this.$message({
            message: res.msg,
            type: "success",
          });
        }          
      })
    },
    addSuffix(_id, suffix) {
      if (!document.getElementById("_suffix_"+_id)) {
        const span = document.createElement('span');
        span.id="_suffix_"+_id;
        const innerspan = document.createElement('span');
        const textspan = document.createElement('span'); 
        
        span.setAttribute("class","el-input__suffix");
        span.setAttribute("style","right:6px");
        innerspan.setAttribute("class","el-input__suffix-inner");
        
        span.append(innerspan)
        innerspan.append(textspan)
        textspan.append(suffix)
        
        document.getElementById(_id).lastElementChild.prepend(span);
      }
    },
    validXblnr() {
      this.$refs.dialogForm.validate(async (valid) => {        
        if (valid) {
          let res = await apiSapOrderValidXblnr({
            ...this.dialogForm,
          });
          if (res.code == 0) {
            this.$message({
              message: res.data ? res.data : res.msg,
              type: "success",
            });
          }
        }
      });
    },
    async submitData() {
      this.$refs.dialogForm.validate(async (valid) => {        
        if (valid) {
          let res = await apiSapOrderStorage({
            ...this.dialogForm,
          });
          if (res.code == 0) {
            this.lgortList=[];
            this.$refs.myDialog.dialogVisible = false;
            this.onSearch();
            this.$message({
              message: res.msg,
              type: "success",
            });
          }
        }
      });      
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
    },
    async onSearch(callback) {
      const res = await apiSapStorageSearch({
        id: this.tabPaneValue,
      });
      if (res.code == 0) {
        this.itemList = res.data;
        this.$parent.orderStatus = (res.data2 ? res.data2.orderStatus : null);
        if (callback) callback();
      }
    },
    onPrintStorage() {
      const h = this.$createElement;
      let number = 0;
      this.$msgbox({
        title: `打印入库单！`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请填写入库送货单数量:`
          ),
          h("i", { style: "color: #F56C6C;white-space:pre !important;" }),
          h("span", null, ``),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            number = instance.inputValue;
            var numReg = /^[0-9]*$/
            var numRe = new RegExp(numReg)
            if (!numRe.test(number)) {
              this.$message({
                message: `请输入数字！`,
                type: "warning",
              });
              return;
            }else{
              done();
            }
          } else {
            done();
          }
        },
      }).then(async () => { 
        
        const res = await apiSapOrderStoragePrint({
          id: this.tabPaneValue,
          value: number,
        });

        const reader = new FileReader()
        reader.readAsText(res, "utf-8")
        reader.onload =  (e) => {
          // 将会打印json格式
          const jsonData = JSON.parse(e.target.result);
          if(jsonData.code != 0){
            this.showMessage(jsonData.msg)
          }
        }
        //打印
        const blob = new Blob([res], { type: 'application/pdf;charset=utf-8' });
        var date = (new Date()).getTime()
        var ifr = document.createElement('iframe')
        ifr.style.frameborder = 'no'
        ifr.style.display = 'none'
        ifr.style.pageBreakBefore = 'always'
        ifr.setAttribute('id', 'printPdf' + date)
        ifr.setAttribute('name', 'printPdf' + date)
        ifr.src = window.URL.createObjectURL(blob)
        document.body.appendChild(ifr)
        this.doPrint('printPdf' + date)
        window.URL.revokeObjectURL(ifr.src)
        
        

      })
    },
    showMessage(msg) {
      this.$message({
        message: msg,
        type: "error",
      });
    },
    doPrint(val) {
      var ordonnance = document.getElementById(val).contentWindow
      setTimeout(() => {
        ordonnance.print()
      }, 100)
}
  }
};
</script>
<style>
  .el-table .warning-row {
    color: #F56C6C;
  }
  .processPage .el-table {
    /* 确保行悬停背景色覆盖整行所有列 */
    tbody tr:hover td {
      background-color: var(--bgHover) !important;
    }
    /* 斑马纹行的悬停背景色覆盖 */
    .el-table__row--striped:hover td {
      background-color: var(--bgHover) !important;
    }
  }
</style>
